import { Subscription } from '@wix/ambassador-billing-v1-subscription/types';
import { useTranslation, useBi } from '@wix/yoshi-flow-editor';
import React from 'react';
import { TextButton } from 'wix-ui-tpa';
import { connect } from '../../../../common/components/runtime-context';
import { IActionCreators } from '../../../../types/internal-types';
import { RootState } from '../../state';
import { classes } from './SubscriptionsListItemBass.st.css';
import { aClickUpmCtaEvent } from '@wix/bi-logger-my-subscriptions/v2';

type RuntimeProps = ReturnType<typeof mapRuntimeToProps>;

interface Props {
  subscription: Subscription;
}
const UpmCta = ({ subscription, actionCreators }: Props & RuntimeProps) => {
  const { t } = useTranslation();
  const biLogger = useBi();
  const onCtaClick = () => {
    biLogger.report(
      aClickUpmCtaEvent({
        cycle: subscription.billingStatus?.currentCycle,
        cycleAutoRenew: subscription.billingSettings?.cycleAutoRenew,
        nextBillingDate: subscription.billingStatus?.nextBillingDate?.getTime(),
        paymentMethodId: subscription.billingSettings?.paymentMethod?.id,
        previousBillingDate: subscription.billingStatus?.previousBillingDate?.getTime(),
        subscriptionId: subscription.id!,
        subscription_status: subscription.status,
      }),
    );
    actionCreators.openUpmModal(subscription.id!);
  };

  return (
    <TextButton data-hook="upm-cta-button" className={classes.cta} onClick={onCtaClick}>
      {t('app.settings.default.update-payment.text')}
    </TextButton>
  );
};

const mapRuntimeToProps = (_state: RootState, _props: Props, actionCreators: IActionCreators) => {
  return {
    actionCreators,
  };
};

export default connect(mapRuntimeToProps)(UpmCta);
